import type { SoloMode } from "../features/solo/soloMode.ts";
import { messages } from "../i18n/index.ts";

interface SoloModeTabsProps {
  value: SoloMode;
  onChange: (mode: SoloMode) => void;
}

const OPTIONS: readonly { value: SoloMode; label: string }[] = [
  { value: "classic", label: messages.solo.modeClassic },
  { value: "timed", label: messages.solo.modeTimed },
];

/** Tek Başına Oyna'nın üstündeki Klasik | 3 Dakika seçimi. */
export function SoloModeTabs({ value, onChange }: SoloModeTabsProps) {
  return (
    <div className="solo-tabs">
      <div className="history-tabs" role="radiogroup" aria-label={messages.solo.modeLabel}>
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={option.value === value}
            className="history-tab"
            onClick={() => { if (option.value !== value) onChange(option.value); }}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
